import * as React from "react";
import styled, { ThemeProvider } from "styled-components";
import Header from "../Header";
import HeaderV2 from "../HeaderV2";
import Footer from "../Footer";
import FooterV2 from "../Footer/FooterV2";
import MailingList from "../MailingList";
import MailingListV2 from "../MailingList/MailingListV2";
import Cookies from "../Cookies";
import useRightToLeft from "../../hooks/useRightToLeft";
import SignUpModal from "../SignUpModal/SignUpModal";
import LanguagePickerModal from "../LanguagePickerModal";
import { FONTS } from "../../helpers/theme";
import { useFontFamily } from "../../hooks/useFontFamily";
import Userway from "../Userway";
import { isUSLocale } from "../../helpers/locales";

export type PageProps = {
  children: React.ReactNode;
  helmet: React.ReactNode;
  displayHeader?: boolean;
  displayFooter?: boolean;
  displayMailing?: boolean;
  initialHeaderBackgroundColor?: string;
  initialHeaderFontColor?: string;
  scrolledHeaderBackgroundColor?: string;
  scrolledHeaderFontColor?: string;
  hideInitialPopup?: boolean;
};

const Page = ({
  children,
  helmet,
  initialHeaderBackgroundColor,
  initialHeaderFontColor,
  scrolledHeaderBackgroundColor,
  scrolledHeaderFontColor,
  displayHeader = true,
  displayFooter = true,
  displayMailing = true,
  hideInitialPopup = false,
}: PageProps): JSX.Element => {
  const isRTL = useRightToLeft();
  const fontFamily = useFontFamily();

  const theme = {
    fontFamily: fontFamily || FONTS.SHARP_SANS_DISPLAY_NO1,
    fallBackFontFamily: FONTS.SHARP_SANS_DISPLAY_NO1,
    fontGtAlpina: FONTS.GT_ALPINA,
    fontGtPressura: FONTS.GT_PRESSURA,
    isRTL,
  };

  const reskin = isUSLocale();

  const headerV2InitialBackgroundColor = "#F6F1E7";
  const headerV2ScrolledBackgroundColor = "#F6F1E7";
  const headerV2InitialFontColor = "#012604";
  const headerV2ScrolledFontColor = "#012604";

  React.useEffect(() => {
    document.documentElement.classList.toggle("reskin", reskin);
  }, []);

  return (
    <>
      <Cookies />
      <Userway />
      <ThemeProvider theme={theme}>
        {helmet}
        {displayHeader &&
          (reskin ? (
            <HeaderV2
              initialHeaderBackgroundColor={headerV2InitialBackgroundColor}
              initialHeaderFontColor={headerV2InitialFontColor}
              scrolledHeaderBackgroundColor={headerV2ScrolledBackgroundColor}
              scrolledHeaderFontColor={headerV2ScrolledFontColor}
            />
          ) : (
            <Header
            initialHeaderBackgroundColor={initialHeaderBackgroundColor}
            initialHeaderFontColor={initialHeaderFontColor}
            scrolledHeaderBackgroundColor={scrolledHeaderBackgroundColor}
            scrolledHeaderFontColor={scrolledHeaderFontColor}
          />
        ))}
        <Main>
          {children}

          {displayMailing &&
            (reskin ? (
              <MailingListV2 />
            ) : (
              <MailingList />
          ))}
        </Main>
        {displayFooter && (reskin ? <FooterV2 /> : <Footer />)}
        <SignUpModal hideInitially={hideInitialPopup} />
        <LanguagePickerModal />
      </ThemeProvider>
    </>
  );
};

const Main = styled.main`
  direction: ${(props) => (props.theme.isRTL ? "rtl" : "ltr")};

  .grecaptcha-badge {
    z-index: 10;
  }
`;

export default Page;
